import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  error: null,
  totalCars: 0,
  searchText: "",
  partDetails: {
    dataSource: [],
    columns: [],
    headers: "",
    totalCars: 0
  },
  openedDropdownRowId: null,
  expandedRowDetails: {
    loading: false,
    dataSource: [],
    columns: []
  },
  preFilledDetails: {
    loading: false,
    details: {}
  },
  orderManualPart: {
    loading: false
  },
  vendorsListDetails: {
    loading: false,
    vendorsList: []
  },
  pagination: { pageSize: 20, currentPage: 1 },
  fileDownloading: false,
  ascendingSort: null,
  invoiceOCRDetails: {
    loading: false
  }
};

const fetchPartStart = (state) => ({
  ...state,
  loading: true
});

const fetchPartSuccess = (state, action) => ({
  ...state,
  loading: false,
  totalCars: action.data.totalCars,
  partDetails: {
    dataSource: action.data.dataSource,
    columns: action.data.columns,
    headers: action.data.headers,
    totalCars: action.data.totalCars
  },
  pagination: {
    ...state.pagination,
    pageSize: action.data.pageSize
  }
});

const fetchPartFailure = (state) => ({
  ...state,
  loading: false
});

const fetchPartDropdownStart = (state) => ({
  ...state,
  expandedRowDetails: {
    loading: true
  }
});

const fetchPartDropdownSuccess = (state, action) => ({
  ...state,
  expandedRowDetails: {
    loading: false,
    dataSource: action.data.dataSource,
    column: action.data.columns
  }
});

const fetchPartDropdownFail = (state) => ({
  ...state
});

const setCurrentPage = (state, action) => ({
  ...state,
  pagination: {
    ...state.pagination,
    currentPage: action.data
  }
});

const setPageSize = (state, action) => {
  const {
    partDetails: { totalCars },
    pagination: { currentPage }
  } = state;
  const lastPage = totalCars / action.data;

  return {
    ...state,
    pagination: {
      ...state.pagination,
      pageSize: action.data,
      currentPage: lastPage > currentPage ? currentPage : Math.ceil(lastPage)
    }
  };
};

const setSearchInput = (state, action) => ({
  ...state,
  searchText: action.data,
  pagination: {
    ...state.pagination,
    currentPage: 1
  }
});

const getDropdownDetailsStart = (state) => ({
  ...state,
  preFilledDetails: {
    loading: true,
    details: {}
  }
});

const resetDropdownDetails = (state) => ({
  ...state,
  preFilledDetails: {
    loading: false,
    details: {}
  }
});

const getDropdownDetailsSuccess = (state, action) => ({
  ...state,
  preFilledDetails: {
    loading: false,
    details: action.data
  }
});
const getDropdownDetailsFail = (state) => ({
  ...state,
  preFilledDetails: {
    loading: false,
    details: {}
  }
});

const fileDownloadStart = (state) => ({
  ...state,
  fileDownloading: true
});
const fileDownloadSuccess = (state) => ({
  ...state,
  fileDownloading: false
});
const fileDownloadFail = (state) => ({
  ...state,
  fileDownloading: false
});

const orderManualPartStart = (state) => ({
  ...state,
  orderManualPart: {
    loading: true
  }
});

const orderManualPartSuccess = (state) => ({
  ...state,
  orderManualPart: {
    loading: false
  }
});
const orderManualPartFail = (state) => ({
  ...state,
  orderManualPart: {
    loading: false
  }
});
const fetchOrderVendorStart = (state) => ({
  ...state,
  vendorsListDetails: {
    loading: true
  }
});

const fetchOrderVendorSuccess = (state, action) => ({
  ...state,
  vendorsListDetails: {
    loading: false,
    vendorsList: action.data
  }
});

const fetchOrderVendorFail = (state) => ({
  ...state,
  vendorsListDetails: {
    loading: false
  }
});

const setAscendingSort = (state, action) => ({
  ...state,
  ascendingSort: action.sortingOrder
});
const setOpenedDropdownId = (state, action) => ({
  ...state,
  openedDropdownRowId: action.id
});

const resetPartsInventory = (state) => ({
  ...initialState,
  vendorsListDetails: {
    loading: false,
    vendorsList: state.vendorsListDetails.vendorsList
  },
  openedDropdownRowId: state.openedDropdownRowId
});

const fetchInvoiceOCRDetailsStart = (state) => ({
  ...state,
  invoiceOCRDetails: {
    loading: true
  }
});

const fetchInvoiceOCRDetailsSuccess = (state) => ({
  ...state,
  invoiceOCRDetails: {
    loading: false
  }
});

const fetchInvoiceOCRDetailsFail = (state) => ({
  ...state,
  invoiceOCRDetails: {
    loading: false
  }
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PARTS_START:
      return fetchPartStart(state, action);
    case actionTypes.FETCH_PARTS_SUCCESS:
      return fetchPartSuccess(state, action);
    case actionTypes.FETCH_PARTS_FAIL:
      return fetchPartFailure(state, action);
    case actionTypes.FETCH_PARTS_DROPDOWN_START:
      return fetchPartDropdownStart(state, action);
    case actionTypes.FETCH_PARTS_DROPDOWN_SUCCESS:
      return fetchPartDropdownSuccess(state, action);
    case actionTypes.FETCH_PARTS_DROPDOWN_FAIL:
      return fetchPartDropdownFail(state, action);
    case actionTypes.SET_PARTS_CURRENT_PAGE:
      return setCurrentPage(state, action);
    case actionTypes.SET_PAGE_SIZE:
      return setPageSize(state, action);
    case actionTypes.SET_PARTS_SEARCH_INPUT:
      return setSearchInput(state, action);
    case actionTypes.GET_DROPDOWN_DETAILS_START:
      return getDropdownDetailsStart(state, action);
    case actionTypes.RESET_DROPDOWN_DETAILS:
      return resetDropdownDetails(state);
    case actionTypes.GET_DROPDOWN_DETAILS_SUCCESS:
      return getDropdownDetailsSuccess(state, action);
    case actionTypes.GET_DROPDOWN_DETAILS_FAIL:
      return getDropdownDetailsFail(state, action);
    case actionTypes.DOWNLOAD_FILE_START:
      return fileDownloadStart(state, action);
    case actionTypes.DOWNLOAD_FILE_SUCCESS:
      return fileDownloadSuccess(state, action);
    case actionTypes.DOWNLOAD_FILE_FAIL:
      return fileDownloadFail(state, action);
    case actionTypes.ORDER_MANUAL_PART_START:
      return orderManualPartStart(state, action);
    case actionTypes.ORDER_MANUAL_PART_SUCCESS:
      return orderManualPartSuccess(state, action);
    case actionTypes.ORDER_MANUAL_PART_FAIL:
      return orderManualPartFail(state, action);
    case actionTypes.FETCH_ORDER_VENDOR_START:
      return fetchOrderVendorStart(state, action);
    case actionTypes.FETCH_ORDER_VENDOR_SUCCESS:
      return fetchOrderVendorSuccess(state, action);
    case actionTypes.FETCH_ORDER_VENDOR_FAIL:
      return fetchOrderVendorFail(state, action);
    case actionTypes.EDIT_PART_DETAILS_START:
      return orderManualPartStart(state, action);
    case actionTypes.EDIT_PART_DETAILS_SUCCESS:
      return orderManualPartSuccess(state, action);
    case actionTypes.EDIT_PART_DETAILS_FAIL:
      return orderManualPartFail(state, action);
    case actionTypes.SET_ASCENDING_SORT:
      return setAscendingSort(state, action);
    case actionTypes.SET_OPENED_DROPDOWN_ROW_ID:
      return setOpenedDropdownId(state, action);
    case actionTypes.RESET_PARTS_INVENTORY:
      return resetPartsInventory(state);
    case actionTypes.FETCH_INVOICE_OCR_DETAILS_START:
      return fetchInvoiceOCRDetailsStart(state);
    case actionTypes.FETCH_INVOICE_OCR_DETAILS_SUCCESS:
      return fetchInvoiceOCRDetailsSuccess(state);
    case actionTypes.FETCH_INVOICE_OCR_DETAILS_FAIL:
      return fetchInvoiceOCRDetailsFail(state);
    default:
      return state;
  }
};

export default reducer;
